export const SHOP_STORE_ID = 'shop';
